module.exports = __webpack_public_path__ + "img/excel.6aaa51ae.jpg";